import initialMetricsPublisher from "src/metrics";
import { logger } from "src/logger";

const SCRIPT_ERROR = 'ScriptError';

function filterErrors(errorMessage : string) {
    return errorMessage == "Script error.";
}

export function setUpGlobalErrorLogging(window: any) {
    const scriptErrorMetricsPublisher =
        initialMetricsPublisher.newChildActionPublisherForMethod("BADASSellerCentralWebsite");

    window.addEventListener("error", (event: ErrorEvent) => {
        const { message, lineno, colno, error, filename } = event;

        //Filter out noisy script errors that contain no helpful information
        if(!filterErrors(message)) {
            logger.error("An uncaught JS error occurred." + " Message: " + message +
                " Line: " + lineno + " Column: " + colno + " Source: " + filename + " Error Object: ", error);
            scriptErrorMetricsPublisher.publishCounter(SCRIPT_ERROR, 1);
        }

    });
}
